<template>
  <div style=" width: 1200px; margin: 0 auto; background-color: #F2F6FC;  ">
    <Title :title="{name: '外出申请',path:'/item'}"></Title>

    <el-card class="box-card" style="min-height: 650px;margin-top: 15px;">
      <el-form ref="outReportForm" :model="outReportForm" :rules="outReportRules" label-position="left"
               label-width="150px">
        <el-divider content-position="left">外出信息</el-divider>
        <el-form-item v-show="false" label="申请时间" prop="applyTime">
        </el-form-item>

        <el-form-item prop="ccUserId" label-width="150px" label="抄送人员">
          <el-select
              v-model="outReportForm.ccUserId"
              placeholder="请选择抄送人员"
              multiple
              filterable
          >
            <el-option
                v-for="item in allSysUser"
                :key="item.userId"
                :label="item.realName"
                :value="item.userId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="外出类型" prop="hasProject" required>
          <el-radio-group v-model="outReportForm.hasProject">
            <el-radio label="1">项目外出</el-radio>
            <el-radio label="2">其他外出</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="outReportForm.hasProject==1" label="外出项目" prop="projectId">
          <el-select v-model="outReportForm.projectId" placeholder="请选择报备项目" filterable>
            <el-option
                v-for="item in allSysProject"
                :key="item.projectId"
                :label="item.projectName"
                :disabled="item.projectState === 6"
                :value="item.projectId">
                <span style="float: left">{{ item.projectName }}&nbsp&nbsp{{item.projectIden}}</span>&nbsp&nbsp
                <el-tag v-if="item.projectState === 6" type="info" size="mini">S: 已终止</el-tag>
                <span style="float: left">&nbsp&nbspM: {{ item.managerName }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="外出人员" prop="userIdStr" filterable>
          <el-select v-model="outReportForm.userIdStr" multiple placeholder="可选择多个外出人员">
            <el-option
                v-for="item in allSysUser"
                :key="item.userId"
                :label="item.realName"
                :value="item.userId+':'+item.realName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="外出时间" prop="outTimes">
          <el-date-picker
            @change="clear"
            v-model="outReportForm.outBegainTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="'23:59:59'"
            :picker-options="pickerOptions"
            placeholder="开始时间">
          </el-date-picker>
          <span style="margin: 0 8px">至</span>
          <el-date-picker
            :readonly="endDisabled"
            @focus="dis"
            v-model="outReportForm.outEndTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="endtimeOption"
            placeholder="结束时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="外出形式" prop="publicTransport" required>
          <el-radio-group v-model="outReportForm.publicTransport">
            <el-radio label="1">公共交通</el-radio>
            <el-radio label="2">自驾</el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="outReportForm.publicTransport === '2'">
          <el-alert
              title="温馨提示:自驾出行同行人费用统一由车主报销"
              type="warning"
              show-icon
              :closable="false"
              style="margin-bottom: 10px"
          />

          <!-- 自驾承诺 -->
          <el-form-item label="自驾出行承诺" prop="drivePromiseConfirm" required>
            <el-button type="text" @click="showDrivePromise = true">查看承诺</el-button>
            <el-tag
                :type="outReportForm.drivePromiseConfirm ? 'success' : 'warning'"
                style="margin-left: 10px"
            >
              {{ outReportForm.drivePromiseConfirm ? '已确认' : '未确认(请先阅读并确认自驾出行承诺)' }}
            </el-tag>
          </el-form-item>

          <!-- 是否替驾 -->
          <el-form-item label="是否需要替驾" prop="needDriver">
            <el-radio-group v-model="outReportForm.needDriver">
              <el-radio label="0">否</el-radio>
              <el-radio label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>

          <!-- 替驾声明 -->
          <el-form-item
              v-if="outReportForm.needDriver === '1'"
              label="替驾出行申明"
              prop="driverStatementConfirm"
              required
          >
            <el-button type="text" @click="showDriverStatement = true">
              查看申明
            </el-button>
            <el-tag
                :type="outReportForm.driverStatementConfirm ? 'success' : 'warning'"
                style="margin-left: 10px"
            >
              {{ outReportForm.driverStatementConfirm ? '已确认' : '未确认(请先阅读并确认替驾出行申明)' }}
            </el-tag>
          </el-form-item>

          <!-- 替驾人员 -->
          <el-form-item
              v-if="outReportForm.needDriver === '1' && outReportForm.driverStatementConfirm"
              label="替驾人员"
              prop="driverUserId"
              required
          >
            <el-select
                v-model="outReportForm.driverUserId"
                placeholder="请选择替驾人员"
                filterable
            >
              <el-option
                  v-for="item in driverUserOptions"
                  :key="item.userId"
                  :label="item.realName"
                  :value="item.userId"
              />
            </el-select>
          </el-form-item>
        </template>
        <el-form-item label="外出地点" prop="outAddress">
          <el-input v-model="outReportForm.outAddress"></el-input>
        </el-form-item>
        <el-form-item label="外出事由" prop="outSubject">
          <el-input type="textarea" rows=5 maxlength="500" show-word-limit
                    v-model="outReportForm.outSubject"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button v-if="submitShow" type="primary" @click="newOutReport">提交申请</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-dialog title="自驾出行承诺" :visible.sync="showDrivePromise" width="500px">
      <div>
        <p>1. 本人车辆保险齐全有效，符合公司要求；</p>
        <p>2. 将严格遵守交通法规及公司制度，安全驾驶；</p>
        <p>3. 出车前已对车辆轮胎、灯光、刹车等进行自查。</p>
      </div>

      <span slot="footer">
        <el-button @click="showDrivePromise = false">取消</el-button>
        <el-button type="primary" @click="confirmDrivePromise">确认</el-button>
      </span>
    </el-dialog>

    <el-dialog title="替驾出行申明" :visible.sync="showDriverStatement" width="500px">
      <div>
        <p>1. 替驾人须有两年以上驾龄，并具备高速经验；</p>
        <p>2. 替驾人须为公司在册备案人员。</p>
      </div>

      <span slot="footer">
        <el-button @click="showDriverStatement = false">取消</el-button>
        <el-button type="primary" @click="confirmDriverStatement">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment';
import Title from "../../Title";
import {requestApplyDetail, requestOutReportApply, requestProjectAllGet, requestUserGet} from "@/api";

export default {
  name: "OutReportApply",
  components: {Title},
  data() {
    let disabledDate = time => {
      return time.getTime() < Date.now() - 8.64e7;
    };
    return {
      endDisabled: true,
      applyId: "",
      applyServiceId: "",
      applyType: "",
      reapply: false,

      submitShow: true,
      allSysUser: {},
      table: {},
      allSysProject: {},
      outReportType: 1,
      outReportForm: {
        ccUserId: null, // 抄送人员
        outSubject: '',  //外出事由
        outTimes: '',   //外出时间
        applyTime: '',  //申请时间与日期
        projectId: '',  //项目ID
        outAddress: '', //外出地址
        userIdStr: '',  //外出人员ID
        outBegainTime: '', //外出开始时间
        outEndTime: '',  //外出结束时间
        hasProject: '1', //默认项目外出
        publicTransport: '1', //默认公共交通
        drivePromiseConfirm: false, //自驾承诺确认状态
        needDriver: '0', //默认不需要替驾
        driverStatementConfirm: false, //替驾确认状态
        driverUserId: null //替驾人员ID
      },
      showDrivePromise: false,
      showDriverStatement: false,
      pickerOptions: {
        disabledDate,
        selectableRange: [],
      },
      endtimeOption: {
      },
      outReportRules: {
        projectId: [
          {required: true, message: '请选择报备项目', trigger: 'blur'}
        ],
        userIdStr: [
          {required: true, message: '请选择外出人员', trigger: 'blur'}
        ],
        outAddress: [
          {required: true, message: '请填写外出地点', trigger: 'blur'},
          {min: 2, max: 100, message: '长度在 2 到 100 个字符', trigger: 'change'}
        ],
        outSubject: [
          {required: true, message: '请填写外出事由', trigger: 'blur'},
          {min: 2, max: 500, message: '长度在 2 到 500 个字符', trigger: 'change'}
        ],
        outTimes: [
          {required: true, message: '请选择外出时间', trigger: 'blur'}
        ],
        drivePromiseConfirm: [
          {
            validator: (rule, value, callback) => {
              if (
                  this.outReportForm.publicTransport === '2' &&
                  !value
              ) {
                callback(new Error('请确认自驾出行承诺'));
              } else {
                callback();
              }
            },
            trigger: 'change'
          }
        ],
        driverStatementConfirm: [
          {
            validator: (rule, value, callback) => {
              if (
                  this.outReportForm.needDriver === '1' &&
                  !value
              ) {
                callback(new Error('请确认替驾出行申明'));
              } else {
                callback();
              }
            },
            trigger: 'change'
          }
        ],
        driverUserId: [
          {
            validator: (rule, value, callback) => {
              if (
                  this.outReportForm.needDriver === '1' &&
                  this.outReportForm.driverStatementConfirm &&
                  !value
              ) {
                callback(new Error('请选择替驾人员'));
              } else {
                callback();
              }
            },
            trigger: 'change'
          }
        ]
      }
    }
  },
  watch: {
    'outReportForm.outBegainTime'(n) {
      this.endDisabled = !n
      this.selectable();
    },
    'outReportForm.outEndTime'() {
      // 如果选择的结束时间不是当天，重置可以选择的时间
      const date = moment(this.outReportForm.outEndTime).startOf('day').format('x');
      const nowDate = moment(this.outReportForm.outBegainTime).startOf('day').format('x');
      const h = this.outReportForm.outBegainTime.split(' ')[1]
      // 如果选择的是今天 则需要禁用已经过去的时间节点
      if (date <= nowDate) {
        this.endtimeOption.selectableRange = (
          `${h} - 23:59:59`
        );
      }
	    else {
        this.endtimeOption.selectableRange = '00:00:00 - 23:59:59';
      }
      let arr =[]
      arr[0] = this.outReportForm.outBegainTime
      arr[1] = this.outReportForm.outEndTime
      this.outReportForm.outTimes = arr
    },
    'outReportForm.publicTransport'(val) {
      if (val !== '2') {
        this.outReportForm.drivePromiseConfirm = false
        this.outReportForm.needDriver = '0'
        this.outReportForm.driverStatementConfirm = false
        this.outReportForm.driverUserId = null
      }
    },
    'outReportForm.needDriver'(val) {
      if (val !== '1') {
        this.outReportForm.driverStatementConfirm = false
        this.outReportForm.driverUserId = null
      } else {
        // 重新选择“是”，必须重新确认
        this.outReportForm.driverStatementConfirm = false
        this.outReportForm.driverUserId = null
      }
    },
    'outReportForm.userIdStr'(val) {
      if (!val || !val.length) {
        this.outReportForm.driverUserId = null
        return
      }

      const ids = val.map(item => item.split(':')[0])

      if (!ids.includes(String(this.outReportForm.driverUserId))) {
        this.outReportForm.driverUserId = null
      }
    }
  },
  methods: {
    clear() {
      this.outReportForm.outEndTime = ""
    },
    dis() {
      if (this.outReportForm.outBegainTime) {
        const h = this.outReportForm.outBegainTime.split(' ')[1]
        let form = this.outReportForm
        this.endtimeOption = {
          disabledDate: function (time) {
            return time.getTime() < moment(form.outBegainTime).valueOf() - 8.64e7
          },
          selectableRange: `${h} - 23:59:59`,
        }
      }
    },
    selectable() {
      // 禁用今天的时间以及修改结束时间不能小于开始时间
      const date = moment(this.outReportForm.outBegainTime).startOf('day').format('x');
      const nowDate = moment().startOf('day').format('x');
      // 如果选择的是今天 则需要禁用已经过去的时间节点
      if (date <= nowDate) {
        this.pickerOptions.selectableRange = (
          `${moment().add(1, 'minutes').format('HH:mm:ss')} - 23:59:59`
        );
      }
	    else {
        this.pickerOptions.selectableRange = '00:00:00 - 23:59:59';
      }
    },
    newOutReport() {
      this.$refs['outReportForm'].validate((isPass) => {
        if (isPass) {
          this.outReportForm.ccUserId =
              this.outReportForm.ccUserId && this.outReportForm.ccUserId.length
                  ? this.outReportForm.ccUserId.join(",")
                  : null;
          this.outReportForm.userIdStr = encodeURIComponent(this.outReportForm.userIdStr.join(","));
          this.outReportForm.outBegainTime = this.outReportForm.outTimes[0];
          this.outReportForm.outEndTime = this.outReportForm.outTimes[1];
          this.outReportForm.outTimes = null;
          this.outReportForm.applyTime = null;
          this.submitShow = false;
          if (this.outReportForm.hasProject == 2) {
            this.outReportForm.projectId = "0"
          }
          requestOutReportApply(this.outReportForm).then(res => {
            if (res.code === 200) {
              this.$message.success(res.msg);
              // 重新申请完之后清空路径参数
              if (this.reapply) {
                this.$router.push({query: {}})
                this.reapply = false
              }
              this.resetForm('outReportForm')
              this.submitShow = true
            } else {
              this.$message.error(res.msg);
              this.submitShow = true
            }
          })
        }
      })
    },
    async loadSysUserData() {
      let res = await requestUserGet();
      if (res.code == 200) {
        this.allSysUser = res.object;
        for (let i = 0; i < res.object.length; i++) {
          this.table[res.object[i].realName] = res.object[i].userId
        }
      } else {
        this.$message.error("获取人员列表失败")
      }
    },
    async loadSysProjectData() {
      let res = await requestProjectAllGet();
      if (res.code == 200) {
        this.allSysProject = res.object;
      } else {
        this.$message.error("获取项目列表失败")
      }
    },
    getObject() {
      requestApplyDetail({
        applyId: this.applyId,
        applyServiceId: this.applyServiceId,
        applyType: this.applyType
      }).then(res => {
        if (res.code == 200) {
          if (res.object) {
            let detail = res.object.detail
            this.outReportForm.ccUserId = (detail.ccUserId || '').split(',').filter(id => id && !isNaN(parseInt(id))).map(id => parseInt(id));
            this.outReportForm.projectId = detail.projectId
            this.outReportForm.hasProject = detail.hasProject.toString()
            let users = res.object.outUserNames
            for (let i = 0; i < users.length; i++) {
              this.outReportForm.userIdStr.push(this.table[users[i]] + ':' + users[i])
            }
//            let outTimes = []
//            outTimes.push(detail.outBegainTime)
//            outTimes.push(detail.outEndTime)
//            this.outReportForm.outTimes = outTimes

            this.outReportForm.outBegainTime = detail.outBegainTime
            this.outReportForm.outEndTime = detail.outEndTime
            this.outReportForm.outAddress = detail.outAddress
            this.outReportForm.outSubject = detail.outSubject
            // 重新申请需要的参数
            this.outReportForm.outReportId = detail.outReportId
            this.outReportForm.reapply = this.reapply
            this.outReportForm.applyId = this.applyId
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.outReportForm.projectId = ""
      this.outReportForm.outBegainTime = ""
      this.outReportForm.outEndTime = ""
    },
    confirmDrivePromise() {
      this.outReportForm.drivePromiseConfirm = true
      this.showDrivePromise = false
    },
    confirmDriverStatement() {
      this.outReportForm.driverStatementConfirm = true
      this.showDriverStatement = false
    }
  },
  computed: {
    driverUserOptions() {
      if (!this.outReportForm.userIdStr || !this.outReportForm.userIdStr.length) {
        return []
      }

      // 提取外出人员 userId
      const userIds = this.outReportForm.userIdStr.map(item => {
        return item.split(':')[0]
      })

      // 过滤出对应用户
      return this.allSysUser.filter(user => userIds.includes(String(user.userId)))
    }
  },
  created() {
    this.loadSysProjectData();
    this.loadSysUserData().then(res => {
      this.applyId = this.$route.query.applyId
      this.applyServiceId = this.$route.query.applyServiceId
      this.applyType = this.$route.query.applyType
      if (this.applyId || this.applyServiceId || this.applyType) {
        this.getObject()
        this.reapply = true
      }
    })
  }
}
</script>

<style scoped>

</style>
